// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VsChatbaseRouteImport } from './routes/vs-chatbase'
import { Route as VsBotpressRouteImport } from './routes/vs-botpress'
import { Route as UseCasesRouteImport } from './routes/use-cases'
import { Route as TwinCheckRouteImport } from './routes/twin-check'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SupportRouteImport } from './routes/support'
import { Route as SubprocessorsRouteImport } from './routes/subprocessors'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as RoadmapRouteImport } from './routes/roadmap'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PlatformRouteImport } from './routes/platform'
import { Route as NuvatrRouteImport } from './routes/nuvatr'
import { Route as NetworkRouteImport } from './routes/network'
import { Route as InvestRouteImport } from './routes/invest'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as DpaRouteImport } from './routes/dpa'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TopicsIndexRouteImport } from './routes/topics.index'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as MarketplaceIndexRouteImport } from './routes/marketplace.index'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as DealsIndexRouteImport } from './routes/deals.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as VsSlugRouteImport } from './routes/vs.$slug'
import { Route as TopicsSlugRouteImport } from './routes/topics.$slug'
import { Route as MarketplaceIdRouteImport } from './routes/marketplace.$id'
import { Route as JoinTokenRouteImport } from './routes/join.$token'
import { Route as IndustriesSlugRouteImport } from './routes/industries.$slug'
import { Route as EmbedCompanyIdRouteImport } from './routes/embed.$companyId'
import { Route as DealsIdRouteImport } from './routes/deals.$id'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as BlogWhatIsAnAiTwinRouteImport } from './routes/blog.what-is-an-ai-twin'
import { Route as BlogConvertWebsiteVisitorsWithAiRouteImport } from './routes/blog.convert-website-visitors-with-ai'
import { Route as BlogBotpressAlternativesB2bRouteImport } from './routes/blog.botpress-alternatives-b2b'
import { Route as BlogBestAiChatbotAlternativesB2bRouteImport } from './routes/blog.best-ai-chatbot-alternatives-b2b'
import { Route as BlogAiTwinsForAgenciesRouteImport } from './routes/blog.ai-twins-for-agencies'
import { Route as BlogAiTwinVsChatbotRouteImport } from './routes/blog.ai-twin-vs-chatbot'
import { Route as BlogAiLeadQualificationRouteImport } from './routes/blog.ai-lead-qualification'
import { Route as BlogAiCustomerSupportAutomationRouteImport } from './routes/blog.ai-customer-support-automation'
import { Route as SupportIndexRouteImport } from './routes/support.index'
import { Route as SupportSlugRouteImport } from './routes/support.$slug'
import { Route as DocsTwinPersonalityRouteImport } from './routes/docs.twin-personality'
import { Route as DocsSecurityRouteImport } from './routes/docs.security'
import { Route as DocsQuickstartRouteImport } from './routes/docs.quickstart'
import { Route as DocsPlansAndUsageRouteImport } from './routes/docs.plans-and-usage'
import { Route as DocsMcpServerRouteImport } from './routes/docs.mcp-server'
import { Route as DocsLeadsAndCrmRouteImport } from './routes/docs.leads-and-crm'
import { Route as DocsKnowledgeBaseRouteImport } from './routes/docs.knowledge-base'
import { Route as DocsExchangeRouteImport } from './routes/docs.exchange'
import { Route as DocsEmbedWidgetRouteImport } from './routes/docs.embed-widget'
import { Route as AuthenticatedTwinRouteImport } from './routes/_authenticated/twin'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedRequestsRouteImport } from './routes/_authenticated/requests'
import { Route as AuthenticatedOpportunitiesRouteImport } from './routes/_authenticated/opportunities'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedLeadsRouteImport } from './routes/_authenticated/leads'
import { Route as AuthenticatedKnowledgeRouteImport } from './routes/_authenticated/knowledge'
import { Route as AuthenticatedHelpRouteImport } from './routes/_authenticated/help'
import { Route as AuthenticatedExchangeRouteImport } from './routes/_authenticated/exchange'
import { Route as AuthenticatedDealsRouteImport } from './routes/_authenticated/deals'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCrmRouteImport } from './routes/_authenticated/crm'
import { Route as AuthenticatedConversationsRouteImport } from './routes/_authenticated/conversations'
import { Route as AuthenticatedContractsRouteImport } from './routes/_authenticated/contracts'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedAppointmentsRouteImport } from './routes/_authenticated/appointments'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as DeThemenIndexRouteImport } from './routes/de.themen.index'
import { Route as ServicesPayTokenRouteImport } from './routes/services.pay.$token'
import { Route as DeThemenSlugRouteImport } from './routes/de.themen.$slug'
import { Route as LangTopicsSlugRouteImport } from './routes/$lang.topics.$slug'

const VsChatbaseRoute = VsChatbaseRouteImport.update({
            id: '/vs-chatbase',path: '/vs-chatbase',getParentRoute: () => rootRouteImport
          })
const VsBotpressRoute = VsBotpressRouteImport.update({
            id: '/vs-botpress',path: '/vs-botpress',getParentRoute: () => rootRouteImport
          })
const UseCasesRoute = UseCasesRouteImport.update({
            id: '/use-cases',path: '/use-cases',getParentRoute: () => rootRouteImport
          })
const TwinCheckRoute = TwinCheckRouteImport.update({
            id: '/twin-check',path: '/twin-check',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const SubprocessorsRoute = SubprocessorsRouteImport.update({
            id: '/subprocessors',path: '/subprocessors',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const RoadmapRoute = RoadmapRouteImport.update({
            id: '/roadmap',path: '/roadmap',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PlatformRoute = PlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => rootRouteImport
          })
const NuvatrRoute = NuvatrRouteImport.update({
            id: '/nuvatr',path: '/nuvatr',getParentRoute: () => rootRouteImport
          })
const NetworkRoute = NetworkRouteImport.update({
            id: '/network',path: '/network',getParentRoute: () => rootRouteImport
          })
const InvestRoute = InvestRouteImport.update({
            id: '/invest',path: '/invest',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const DpaRoute = DpaRouteImport.update({
            id: '/dpa',path: '/dpa',getParentRoute: () => rootRouteImport
          })
const DocsRoute = DocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => rootRouteImport
          })
const CustomersRoute = CustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConnectRoute = ConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const ChangelogRoute = ChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TopicsIndexRoute = TopicsIndexRouteImport.update({
            id: '/topics/',path: '/topics/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const MarketplaceIndexRoute = MarketplaceIndexRouteImport.update({
            id: '/marketplace/',path: '/marketplace/',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/industries/',path: '/industries/',getParentRoute: () => rootRouteImport
          })
const DealsIndexRoute = DealsIndexRouteImport.update({
            id: '/deals/',path: '/deals/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const VsSlugRoute = VsSlugRouteImport.update({
            id: '/vs/$slug',path: '/vs/$slug',getParentRoute: () => rootRouteImport
          })
const TopicsSlugRoute = TopicsSlugRouteImport.update({
            id: '/topics/$slug',path: '/topics/$slug',getParentRoute: () => rootRouteImport
          })
const MarketplaceIdRoute = MarketplaceIdRouteImport.update({
            id: '/marketplace/$id',path: '/marketplace/$id',getParentRoute: () => rootRouteImport
          })
const JoinTokenRoute = JoinTokenRouteImport.update({
            id: '/join/$token',path: '/join/$token',getParentRoute: () => rootRouteImport
          })
const IndustriesSlugRoute = IndustriesSlugRouteImport.update({
            id: '/industries/$slug',path: '/industries/$slug',getParentRoute: () => rootRouteImport
          })
const EmbedCompanyIdRoute = EmbedCompanyIdRouteImport.update({
            id: '/embed/$companyId',path: '/embed/$companyId',getParentRoute: () => rootRouteImport
          })
const DealsIdRoute = DealsIdRouteImport.update({
            id: '/deals/$id',path: '/deals/$id',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const BlogWhatIsAnAiTwinRoute = BlogWhatIsAnAiTwinRouteImport.update({
            id: '/blog/what-is-an-ai-twin',path: '/blog/what-is-an-ai-twin',getParentRoute: () => rootRouteImport
          })
const BlogConvertWebsiteVisitorsWithAiRoute = BlogConvertWebsiteVisitorsWithAiRouteImport.update({
            id: '/blog/convert-website-visitors-with-ai',path: '/blog/convert-website-visitors-with-ai',getParentRoute: () => rootRouteImport
          })
const BlogBotpressAlternativesB2bRoute = BlogBotpressAlternativesB2bRouteImport.update({
            id: '/blog/botpress-alternatives-b2b',path: '/blog/botpress-alternatives-b2b',getParentRoute: () => rootRouteImport
          })
const BlogBestAiChatbotAlternativesB2bRoute = BlogBestAiChatbotAlternativesB2bRouteImport.update({
            id: '/blog/best-ai-chatbot-alternatives-b2b',path: '/blog/best-ai-chatbot-alternatives-b2b',getParentRoute: () => rootRouteImport
          })
const BlogAiTwinsForAgenciesRoute = BlogAiTwinsForAgenciesRouteImport.update({
            id: '/blog/ai-twins-for-agencies',path: '/blog/ai-twins-for-agencies',getParentRoute: () => rootRouteImport
          })
const BlogAiTwinVsChatbotRoute = BlogAiTwinVsChatbotRouteImport.update({
            id: '/blog/ai-twin-vs-chatbot',path: '/blog/ai-twin-vs-chatbot',getParentRoute: () => rootRouteImport
          })
const BlogAiLeadQualificationRoute = BlogAiLeadQualificationRouteImport.update({
            id: '/blog/ai-lead-qualification',path: '/blog/ai-lead-qualification',getParentRoute: () => rootRouteImport
          })
const BlogAiCustomerSupportAutomationRoute = BlogAiCustomerSupportAutomationRouteImport.update({
            id: '/blog/ai-customer-support-automation',path: '/blog/ai-customer-support-automation',getParentRoute: () => rootRouteImport
          })
const SupportIndexRoute = SupportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SupportRoute
          })
const SupportSlugRoute = SupportSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => SupportRoute
          })
const DocsTwinPersonalityRoute = DocsTwinPersonalityRouteImport.update({
            id: '/twin-personality',path: '/twin-personality',getParentRoute: () => DocsRoute
          })
const DocsSecurityRoute = DocsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => DocsRoute
          })
const DocsQuickstartRoute = DocsQuickstartRouteImport.update({
            id: '/quickstart',path: '/quickstart',getParentRoute: () => DocsRoute
          })
const DocsPlansAndUsageRoute = DocsPlansAndUsageRouteImport.update({
            id: '/plans-and-usage',path: '/plans-and-usage',getParentRoute: () => DocsRoute
          })
const DocsMcpServerRoute = DocsMcpServerRouteImport.update({
            id: '/mcp-server',path: '/mcp-server',getParentRoute: () => DocsRoute
          })
const DocsLeadsAndCrmRoute = DocsLeadsAndCrmRouteImport.update({
            id: '/leads-and-crm',path: '/leads-and-crm',getParentRoute: () => DocsRoute
          })
const DocsKnowledgeBaseRoute = DocsKnowledgeBaseRouteImport.update({
            id: '/knowledge-base',path: '/knowledge-base',getParentRoute: () => DocsRoute
          })
const DocsExchangeRoute = DocsExchangeRouteImport.update({
            id: '/exchange',path: '/exchange',getParentRoute: () => DocsRoute
          })
const DocsEmbedWidgetRoute = DocsEmbedWidgetRouteImport.update({
            id: '/embed-widget',path: '/embed-widget',getParentRoute: () => DocsRoute
          })
const AuthenticatedTwinRoute = AuthenticatedTwinRouteImport.update({
            id: '/twin',path: '/twin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedRequestsRoute = AuthenticatedRequestsRouteImport.update({
            id: '/requests',path: '/requests',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOpportunitiesRoute = AuthenticatedOpportunitiesRouteImport.update({
            id: '/opportunities',path: '/opportunities',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedLeadsRoute = AuthenticatedLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedKnowledgeRoute = AuthenticatedKnowledgeRouteImport.update({
            id: '/knowledge',path: '/knowledge',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedHelpRoute = AuthenticatedHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedExchangeRoute = AuthenticatedExchangeRouteImport.update({
            id: '/exchange',path: '/exchange',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDealsRoute = AuthenticatedDealsRouteImport.update({
            id: '/deals',path: '/deals',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCrmRoute = AuthenticatedCrmRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedConversationsRoute = AuthenticatedConversationsRouteImport.update({
            id: '/conversations',path: '/conversations',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedContractsRoute = AuthenticatedContractsRouteImport.update({
            id: '/contracts',path: '/contracts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAppointmentsRoute = AuthenticatedAppointmentsRouteImport.update({
            id: '/appointments',path: '/appointments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const DeThemenIndexRoute = DeThemenIndexRouteImport.update({
            id: '/de/themen/',path: '/de/themen/',getParentRoute: () => rootRouteImport
          })
const ServicesPayTokenRoute = ServicesPayTokenRouteImport.update({
            id: '/services/pay/$token',path: '/services/pay/$token',getParentRoute: () => rootRouteImport
          })
const DeThemenSlugRoute = DeThemenSlugRouteImport.update({
            id: '/de/themen/$slug',path: '/de/themen/$slug',getParentRoute: () => rootRouteImport
          })
const LangTopicsSlugRoute = LangTopicsSlugRouteImport.update({
            id: '/$lang/topics/$slug',path: '/$lang/topics/$slug',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,AuthenticatedAppointmentsRoute: AuthenticatedAppointmentsRoute,AuthenticatedBillingRoute: AuthenticatedBillingRoute,AuthenticatedContractsRoute: AuthenticatedContractsRoute,AuthenticatedConversationsRoute: AuthenticatedConversationsRoute,AuthenticatedCrmRoute: AuthenticatedCrmRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedDealsRoute: AuthenticatedDealsRoute,AuthenticatedExchangeRoute: AuthenticatedExchangeRoute,AuthenticatedHelpRoute: AuthenticatedHelpRoute,AuthenticatedKnowledgeRoute: AuthenticatedKnowledgeRoute,AuthenticatedLeadsRoute: AuthenticatedLeadsRoute,AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,AuthenticatedOpportunitiesRoute: AuthenticatedOpportunitiesRoute,AuthenticatedRequestsRoute: AuthenticatedRequestsRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedTwinRoute: AuthenticatedTwinRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const DocsRouteChildren = {
  DocsEmbedWidgetRoute: DocsEmbedWidgetRoute,DocsExchangeRoute: DocsExchangeRoute,DocsKnowledgeBaseRoute: DocsKnowledgeBaseRoute,DocsLeadsAndCrmRoute: DocsLeadsAndCrmRoute,DocsMcpServerRoute: DocsMcpServerRoute,DocsPlansAndUsageRoute: DocsPlansAndUsageRoute,DocsQuickstartRoute: DocsQuickstartRoute,DocsSecurityRoute: DocsSecurityRoute,DocsTwinPersonalityRoute: DocsTwinPersonalityRoute
}

const DocsRouteWithChildren = DocsRoute._addFileChildren(DocsRouteChildren)




const SupportRouteChildren = {
  SupportSlugRoute: SupportSlugRoute,SupportIndexRoute: SupportIndexRoute
}

const SupportRouteWithChildren = SupportRoute._addFileChildren(SupportRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,CareersRoute: CareersRoute,ChangelogRoute: ChangelogRoute,CompareRoute: CompareRoute,ConnectRoute: ConnectRoute,ContactRoute: ContactRoute,CustomersRoute: CustomersRoute,DocsRoute: DocsRouteWithChildren,DpaRoute: DpaRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,ImpressumRoute: ImpressumRoute,InvestRoute: InvestRoute,NetworkRoute: NetworkRoute,NuvatrRoute: NuvatrRoute,PlatformRoute: PlatformRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,RoadmapRoute: RoadmapRoute,SecurityRoute: SecurityRoute,SubprocessorsRoute: SubprocessorsRoute,SupportRoute: SupportRouteWithChildren,TermsRoute: TermsRoute,TwinCheckRoute: TwinCheckRoute,UseCasesRoute: UseCasesRoute,VsBotpressRoute: VsBotpressRoute,VsChatbaseRoute: VsChatbaseRoute,BlogAiCustomerSupportAutomationRoute: BlogAiCustomerSupportAutomationRoute,BlogAiLeadQualificationRoute: BlogAiLeadQualificationRoute,BlogAiTwinVsChatbotRoute: BlogAiTwinVsChatbotRoute,BlogAiTwinsForAgenciesRoute: BlogAiTwinsForAgenciesRoute,BlogBestAiChatbotAlternativesB2bRoute: BlogBestAiChatbotAlternativesB2bRoute,BlogBotpressAlternativesB2bRoute: BlogBotpressAlternativesB2bRoute,BlogConvertWebsiteVisitorsWithAiRoute: BlogConvertWebsiteVisitorsWithAiRoute,BlogWhatIsAnAiTwinRoute: BlogWhatIsAnAiTwinRoute,CheckoutReturnRoute: CheckoutReturnRoute,DealsIdRoute: DealsIdRoute,EmbedCompanyIdRoute: EmbedCompanyIdRoute,IndustriesSlugRoute: IndustriesSlugRoute,JoinTokenRoute: JoinTokenRoute,MarketplaceIdRoute: MarketplaceIdRoute,TopicsSlugRoute: TopicsSlugRoute,VsSlugRoute: VsSlugRoute,BlogIndexRoute: BlogIndexRoute,DealsIndexRoute: DealsIndexRoute,IndustriesIndexRoute: IndustriesIndexRoute,MarketplaceIndexRoute: MarketplaceIndexRoute,ServicesIndexRoute: ServicesIndexRoute,TopicsIndexRoute: TopicsIndexRoute,LangTopicsSlugRoute: LangTopicsSlugRoute,DeThemenSlugRoute: DeThemenSlugRoute,ServicesPayTokenRoute: ServicesPayTokenRoute,DeThemenIndexRoute: DeThemenIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)